import WorkItem from "../WorkItem";

/**
 * İki sütunlu, sağ sütunu aşağı kaydırılmış proje ızgarası (Clay'in iş bölümü gibi).
 */
const WorksList = ({ items = [] }) => (
    <div className="grid grid-cols-1 gap-y-16 md:grid-cols-2 md:gap-x-12 md:gap-y-24 xl:gap-x-[114px] md:[&>*:nth-child(even)]:mt-[120px]">
        {items.map((item, index) => (
            <WorkItem item={item} index={index} key={item.slug} />
        ))}
    </div>
);

export default WorksList;
